import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import lifecycle from 'recompose/lifecycle';
import withState from 'recompose/withState';
import SelectPromotion from '../components/SelectPromotion';
import { getRoleIdType } from '../../auth/selectors';
import {
  fetchOwnerPromoCodes,
} from '../../main/settings/promoCodes/actions';
import { setPromoId } from '../actions';
import withRenderOnPromotion from '../hoc/withRenderOnPromotion';
import withActiveUserIdAndType from '../../common/hoc/withActiveUserIdAndType';

const SelectPromotionContainer = compose(
  withActiveUserIdAndType(),
  withRenderOnPromotion,
  connect(
    state => ({
      promos: state.settings.promoCodes,
      shopOrBarber: getRoleIdType(state),
      selected: state.engagement.campaign.promoId,
    }),
    {
      fetchOwnerPromoCodes,
      setPromoId,
    }
  ),
  withState('loading', 'setLoading', true),
  withHandlers({
    fetch: props => () => props.fetchOwnerPromoCodes(props.activeId, props.activeType),
    selectPromo: props => id => () => {
      const promoId = props.selected === id ? null : id;
      props.setPromoId(promoId);
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetch().then(() => this.props.setLoading(false));
    },
  }),
)(SelectPromotion);

export default SelectPromotionContainer;
